/*@ngInject*/
const approveEndorsementLocale = require('../approveEndorsement/approveEndorsementModal.i18n.json');
const reviewEndorsementLocale = require('../reviewEndorsement/reviewEndorsement.i18n.json');

const EndorsementActionUtil = function ($rootScope, appTypeConfigurationModel, coreConstant, submissionConstant,
                                                       uiPerformanceLoggerConstant, loadingBarHandler,
                                                       modalUtil, umModalUtil, endorsementActionsMediator, coreMediator, $uibModal) {

    this.i18n = {
        approveEndorsement: approveEndorsementLocale,
        reviewEndorsement: reviewEndorsementLocale
    };

    this.reviewChanges = function (endorsementId) {
        endorsementActionsMediator.getEndorsementSummary(endorsementId).then((endorsementSummary) => {
            $uibModal.open({
                templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                controller: 'reviewChangesModalController',
                backdrop: 'static',
                windowClass: 'reviewChangesModal',
                resolve: {
                    options: () => {
                        return {
                            title: _.get(this.i18n, 'reviewEndorsement.reviewChangesTitle'),
                            isReadOnly: false,
                            continueButtonLabel: _.get(this.i18n, 'reviewEndorsement.reviewClose'),
                            changeSetId: endorsementSummary.changeSetId,
                            showCancel: false,
                            entityId: endorsementId
                        };
                    }
                }
            });
        });
    };

    this.createEndorsement = function (endorsementId) {
        let promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, `Endorsement: ${endorsementId}`);
        loadingBarHandler.showLoadingBar('submission.endorsement.creatingEndorsementLoadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        let onSuccess = () => {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, coreConstant.uiPeformanceLogger.SUCCESS);
        };

        let onFailure = () => {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_ENDORSEMENT, coreConstant.uiPeformanceLogger.FAIL);
        };

        promise = endorsementActionsMediator.create(endorsementId).then(onSuccess, onFailure);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.deleteEndorsement = function (endorsementId, submissionId) {
        function handleClose() {
            let promise = endorsementActionsMediator.delete(endorsementId).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            'submission.wizard.deleteEndorsement',
            uiPerformanceLoggerConstant.DELETE_ENDORSEMENT,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.submitEndorsement = function (endorsementId) {
        endorsementActionsMediator.getEndorsementSummary(endorsementId).then((endorsementSummary) => {

            if(!_.isNil(endorsementSummary.changeSetId)) {
                const modalInstance = $uibModal.open({
                    templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                    controller: 'reviewChangesModalController',
                    backdrop: 'static',
                    windowClass: 'reviewChangesModal',
                    resolve: {
                        options: () => {
                            return {
                                title: _.get(this.i18n, 'reviewEndorsement.reviewSubmitTitle'),
                                isReadOnly: false,
                                continueButtonLabel: _.get(this.i18n, 'reviewEndorsement.submitChanges'),
                                changeSetId: endorsementSummary.changeSetId,
                                showCancel: true,
                                entityId: endorsementId,
                                showMessage: appTypeConfigurationModel.isUnderwriterWorkstation()
                            };
                        }
                    }
                });

                modalInstance.result.then(() => {
                    loadingBarHandler.showLoadingBar('submission.endorsement.submittingEndorsementLoadingBar');
                    let promise = endorsementActionsMediator.submit(endorsementId).finally(function () {
                        $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                        loadingBarHandler.hideLoadingBar();
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                });
            } else {
                loadingBarHandler.showLoadingBar(_.get(this.i18n, 'reviewEndorsement.loadingBar'));
                let promise = endorsementActionsMediator.submit(endorsementId).finally(function () {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    loadingBarHandler.hideLoadingBar();
                });
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            }
        });
    };


    this.startRating = function (endorsementId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.endorsement.startRating');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.startRating(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.refreshQuote = function (endorsementId) {
        loadingBarHandler.showLoadingBar('submission.endorsement.refreshQuote');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = endorsementActionsMediator.refreshQuote(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateRating = function (endorsementId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.ratingEngineProcessing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.generateRating(endorsementId).finally(function (response) {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateRatingAttachments = function (endorsementId, submissionId) {
        var dynamicDataSetParams = {
            name: 'Rating Attachment Groups',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
            ownerUri: 'com.firstbest.underwriting.policy.endorsement.Endorsement:' + endorsementId
        };

        function onSuccess(response) {
            var ratingAttachmentGroups = {};

            // Format the response into a mapping of the separate attachment groups, for easier processing in the modal.
            _.each(response, function (dataItem) {
                if (!ratingAttachmentGroups[dataItem.grouping]) {
                    ratingAttachmentGroups[dataItem.grouping] = {
                        name: dataItem.grouping,
                        ratingAttachments: []
                    };
                }

                ratingAttachmentGroups[dataItem.grouping].ratingAttachments.push(dataItem);
            });

            $uibModal.open({
                templateUrl: '/wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html',
                controller: 'generateRatingAttachmentsModalController',
                windowClass: 'generateRatingAttachmentsModalContainer',
                backdrop: 'static',
                resolve: {
                    options: function () {
                        return {
                            ratingAttachmentGroups: ratingAttachmentGroups
                        };
                    }
                }
            }).result.then(function (options) {
                var action = uiPerformanceLoggerConstant.GENERATE_RATING_ATTACHMENTS,
                    message = endorsementId.toString(),
                    promise;

                function onSuccess() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, coreConstant.uiPeformanceLogger.FAIL);
                }

                function onFinally() {
                    $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                    loadingBarHandler.hideLoadingBar();
                }

                loadingBarHandler.showLoadingBar('submission.wizard.generateRatingAttachments.loadingBar');
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

                promise = endorsementActionsMediator.generateRatingAttachments(endorsementId, options.selectedRatingAttachments).then(onSuccess, onError).finally(onFinally);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
        }

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(onSuccess);
    };

    this.startPricing = function (endorsementId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.startPricing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.startPricing(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyPricing = function (endorsementId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyPricing');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.modifyPricing(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifyRating = function (endorsementId, submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyingRating');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.modifyRating(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };


    this.submitEndorsementForIssuance = function (endorsementId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.endorsement.submittingEndorsementForIssuanceLoadingBar');
        promise = endorsementActionsMediator.submitForIssuance(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.markEndorsementAsIssued = function (endorsementId, submissionId) {
        function handleClose() {
            let promise = endorsementActionsMediator.markIssued(endorsementId).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        modalUtil.showConfirmationModal(
            submissionId,
            null/*quoteId*/,
            null/*notificationName*/,
            'submission.wizard.markEndorsementAsIssued',
            uiPerformanceLoggerConstant.MARK_ENDORSEMENT_AS_ISSUED,
            /*hideLoadingBar*/false,
            handleClose);
    };

    this.revertEndorsementToSubmitted = function (endorsementId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.endorsement.revertingEndorsementToSubmittedLoadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.revertToSubmitted(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.revertToPendingIssuance = function (endorsementId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.endorsement.revertingEndorsementToPendingIssuanceLoadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = endorsementActionsMediator.revertToPendingIssuance(endorsementId).finally(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.declineEndorsement = function (endorsementId, submissionId) {
        function handleClose(result) {
            let promise = endorsementActionsMediator.decline(endorsementId, result.reason, result.details).finally(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        umModalUtil.showReasonModal(
            submissionId,
            null/*quoteId*/,
            null,
            null/*reason*/,
            'submission.wizard.reasonModal.declineEndorsementModal',
            false/*isReasonOptional*/,
            uiPerformanceLoggerConstant.DECLINE_ENDORSEMENT,
            handleClose);
    };

    this.approveEndorsement = function (endorsementId, submissionId) {

        const modalInstance = $uibModal.open({
            templateUrl: '/wizard/actions/approveEndorsement/approveEndorsementModal.tpl.html',
            controller: 'approveEndorsementModalController',
            windowClass: 'approveEndorsementModal',
            resolve: {},
            keyboard: false,
            backdrop: 'static'
        });

        modalInstance.result.then((options) => {
            let promise;
            loadingBarHandler.showLoadingBar(this.i18n.approveEndorsement.loading);

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            $rootScope.$broadcast(
                coreConstant.event.START_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.APPROVE_ENDORSEMENT,
                submissionId);

            promise = endorsementActionsMediator.approve(endorsementId, options.processingInstructions).finally( () => {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        });
    };

};

angular.module('gw-um-submission')
    .service('endorsementActionUtil', EndorsementActionUtil);
